<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">Supervision Visit Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <form-require-noti />
      <v-row>
        <v-col lg="3">
          <label>Code <require-sign /></label>
          <v-text-field
            v-model="supervisionData.mdrtb_code"
            hide-details
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col lg="3">
          <label>Year <require-sign /></label>
          <v-text-field
            v-model="supervisionData.mdrtb_year"
            hide-details
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col lg="4">
          <label>Volunteer <require-sign /></label>
          <v-select
            :items="volunteers"
            v-model="supervisionData.volunteer_id"
            @input="changeVolunteer"
            :error-messages="handleFieldErrors($v.supervisionData.volunteer_id)"
            item-value="id"
            dense
            outlined
          >
            <template v-slot:selection="{ item }">
              <span>{{ item.name }} / {{ item.code }}</span>
            </template>
            <template v-slot:item="{ item }">
              <span>{{ item.name }} / {{ item.code }}</span>
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col lg="4">
          <label>DOT Type <require-sign /></label>
          <v-select
            :items="[
              { value: 1, text: `Through DOT application` },
              { value: 2, text: `By DOT Card` },
            ]"
            v-model="supervisionData.dots_type"
            :error-messages="handleFieldErrors($v.supervisionData.dots_type)"
            item-text="text"
            item-value="value"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col lg="4">
          <label>Supervision Type <require-sign /></label>
          <v-select
            :items="[
              { value: 1, text: `In person` },
              { value: 2, text: `By Phone` },
            ]"
            v-model="supervisionData.supervision_type"
            :error-messages="
              handleFieldErrors($v.supervisionData.supervision_type)
            "
            item-text="text"
            item-value="value"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col lg="4">
          <label>Date <require-sign /></label>
          <date-picker
            @clearDate="supervisionData.date = null"
            :validationMsg="handleFieldErrors($v.supervisionData.date)"
            :date="supervisionData.date"
            v-model="supervisionData.date"
            :min="minDate"
            :max="maxDate"
          />
        </v-col>
      </v-row>
      <v-divider />
      <v-simple-table dense>
        <tbody>
          <tr
            v-for="result in supervisionData.radio_value_list"
            :key="result.id"
          >
            <td width="70%">{{ showText(result.id) }}</td>
            <td>
              <v-radio-group
                class="my-2"
                v-model="result[Object.keys(result)[1]]"
                hide-details
                dense
                row
              >
                <v-radio label="Yes" value="2"></v-radio>
                <v-radio label="No" value="1"></v-radio>
              </v-radio-group>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-divider />
      <v-row>
        <v-col class="ml-3 mt-3" lg="8">
          <label>Remark</label>
          <v-text-field
            v-model.trim="supervisionData.remark"
            type="text"
            filled
            dense
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "../../mixins/ValidationMixin";
import { limitDateMixin } from "../../mixins/limitDateMixin";
import { mapState } from "vuex";
import FormRequireNoti from "@/components/notification/FormRequireNoti.vue";
import RequireSign from "@/components/notification/RequireSign.vue";
import DatePicker from "@/components/common/DatePicker.vue";

export default {
  components: { FormRequireNoti, RequireSign, DatePicker },
  mixins: [ValidationMixin, limitDateMixin],
  props: {
    supervisionData: {
      type: Object,
      default: () => {
        return {
          dots_type: null,
          supervision_type: null,
          mdrtb_code: null,
          mdrtb_year: null,
          remark: null,
          date: null,
          radio_value_list: [
            { id: 1, value_1: "1" },
            { id: 2, value_2: "1" },
            { id: 3, value_3: "1" },
            { id: 4, value_4: "1" },
            { id: 5, value_5: "1" },
            { id: 6, value_6: "1" },
            { id: 7, value_7: "1" },
            { id: 8, value_8: "1" },
            { id: 9, value_9: "1" },
            { id: 10, value_9: "1" },
            { id: 11, value_10: "1" },
            { id: 12, value_11: "1" },
          ],
        };
      },
    },
  },
  data: () => ({
    menuDate: null,
    radioText: [
      { id: 1, text: "Performing DOTS regulary" },
      { id: 2, text: "Complete Recording" },
      { id: 3, text: "Wearing N95" },
      { id: 4, text: "Health Education" },
      { id: 5, text: "Using Relevant IEC materials" },
      { id: 6, text: "Has Relevant TB knowledge to share" },
      { id: 7, text: "Side Effect monitoring" },
      { id: 8, text: "Systematic Contact Investigation" },
      { id: 9, text: "Good Communication and Relationship" },
      { id: 10, text: "Good Linkage" },
      { id: 11, text: "Counseling" },
      { id: 12, text: "Others" },
    ],
  }),
  validations: {
    supervisionData: {
      volunteer_id: { required },
      dots_type: { required },
      supervision_type: { required },
      date: { required },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Volunteer", ["volunteers"]),
    ...mapState("Patient", ["patients"]),
  },
  methods: {
    changeVolunteer() {
      if (this.supervisionData.volunteer_id) {
        this.$store.dispatch("Patient/getPatientsByVolunteer", {
          volunteer_id: this.supervisionData.volunteer_id,
        });
      }
    },
    showText(id) {
      let resultText = this.radioText.find((e) => e.id == id);
      if (resultText) return resultText.text;
    },
  },
  created() {
    this.$store.dispatch("Volunteer/getVolunteers");
  },
  beforeMount() {
    this.supervisionData.date = !this.supervisionData.date
      ? this.minDate
      : this.supervisionData.date;
  },
};
</script>

<style scoped></style>
